import { SpinnerWrapper } from "../SpinnerWrapper";
import Position from "../../models/Position";
import { EditDialog } from "../../external/ensolvers-core-frontend-mui/components/EditDialog";
import { DialogPosition } from "../../external/ensolvers-core-frontend-mui/components/Common/DialogPosition";
import PositionFormFields from "./Fields/PositionFormFields";
import AutoCompleteUIDTO from "../../dto/AutoCompleteUIDTO";
import usePositionForm from "../../hooks/usePositionForm";

interface Props {
  externalId?: string;
  editMode?: boolean;
  onClose: (action: "update" | "create" | "canceled") => void;
  userNames?: AutoCompleteUIDTO[];
  projectExternalId?: string;
}

function PositionFormDialog({ externalId, editMode = true, onClose, userNames, projectExternalId }: Props) {
  const {
    isLoading,
    instance,
    showDialog,
    hasWorklogs,
    newBillingPolicy,
    shadowChecked,
    bonusValue,
    handleChangeBillingPolicy,
    handleCheckShadow,
    handleChangeBonus,
    handleUpdatePosition,
    handleCreatePosition,
    handleOnCancel,
  } = usePositionForm({ externalId, editMode, onClose, projectExternalId });

  return (
    <SpinnerWrapper isLoading={isLoading}>
      <EditDialog<Position>
        elementName={"Position"}
        dialogPosition={DialogPosition.Center}
        currentInstance={instance}
        newItemDialogOpen={showDialog}
        onUpdate={(position) => {
          handleUpdatePosition(position);
        }}
        onCreate={(position) => {
          handleCreatePosition(position);
        }}
        onCancel={handleOnCancel}
        renderDialogContent={(register, errors, control) => (
          <PositionFormFields
            control={control}
            register={register}
            errors={errors}
            newBillingPolicy={newBillingPolicy}
            onChangeBillingPolicy={handleChangeBillingPolicy}
            disabledBonusHours={shadowChecked}
            onChangeBonus={handleChangeBonus}
            readonlyShadowCheckbox={hasWorklogs || bonusValue > 0}
            onCheckShadow={handleCheckShadow}
            isEditing={editMode}
            userNames={userNames}
          />
        )}
        buttonStyles={{}}
        setNewInstanceDialogOpen={() => {}}
        setLastUpdateTimestamp={() => {}}
      />
    </SpinnerWrapper>
  );
}

export default PositionFormDialog;
